import { render, staticRenderFns } from "./RightColumn.vue?vue&type=template&id=0775844e&"
import script from "./RightColumn.vue?vue&type=script&lang=js&"
export * from "./RightColumn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports